import axios from "axios";

import { apiRequestHeadersFor } from "api/apiRequestHeaders";
import { projectServiceEndpoint } from "api/project";

/**
 * Tells the server to throw away the part of an upload it has already taken, after
 * the user cancels. Sent with keepalive, so it still goes out while the page is
 * being taken down, and the answer is not waited on: the upload is abandoned here
 * either way, and the server drops an unknown id on its own. The header is the one
 * axios sends on every other call.
 */
export function deleteUploadSession(uploadId: string): void {
  const authorization = axios.defaults.headers.common["Authorization"];

  const url = `${projectServiceEndpoint}/shapefile/upload/${encodeURIComponent(
    uploadId
  )}`;
  fetch(url, {
    method: "DELETE",
    keepalive: true,
    headers: {
      ...apiRequestHeadersFor(url),
      ...(authorization ? { Authorization: String(authorization) } : {})
    }
  }).catch((error) => {
    // eslint-disable-next-line no-console
    console.debug("Could not clean up the cancelled upload:", error);
  });
}
